import React, { useState, useEffect } from 'react';
import AppImage from './AppImage';

interface LogoProps {
  size?: number;
  className?: string;
  variant?: 'full' | 'icon' | 'text';
  color?: 'default' | 'white' | 'gradient';
}

const Logo: React.FC<LogoProps> = ({
  size = 120,
  className = '',
  variant = 'full',
  color = 'default'
}) => {
  const [logoSrc, setLogoSrc] = useState<string>('/assets/images/ihslogo.png');

  useEffect(() => {
    // Check for custom logo in localStorage
    const customLogo = localStorage.getItem('customLogo');
    if (customLogo) {
      setLogoSrc(customLogo);
    }
  }, []);

  // Calculate dimensions based on the original logo aspect ratio
  const height = variant === 'icon' ? size * 0.8 : size;
  const width = height * 1.4; // Nasuman logo is wider than tall

  if (variant === 'text') {
    return (
      <div className={className}>
        <div
          style={{
            fontSize: `${size * 0.4}px`,
            color: color === 'white' ? '#FFFFFF' : '#1e3a5f',
            fontWeight: 700,
            letterSpacing: '-0.02em',
            lineHeight: 1
          }}
        >
          <span>communitySaving</span>
        </div>
      </div>
    );
  }

  // Apply different styles based on color variant
  const imageStyle: React.CSSProperties = {
    width: `${width}px`,
    height: `${height}px`,
    objectFit: 'contain'
  };

  // For white backgrounds, show inverted (white logo)
  if (color === 'white') {
    imageStyle.filter = 'brightness(0) invert(1)';
  }
  // For default, use mix-blend-mode to remove black background
  else if (color === 'default') {
    imageStyle.mixBlendMode = 'multiply';
  }

  return (
    <div
      className={`flex items-center ${className}`}
      style={{ backgroundColor: 'transparent', background: 'transparent' }}
    >
      <AppImage
        src={logoSrc}
        alt="communitySaving"
        style={{ ...imageStyle, backgroundColor: 'transparent', background: 'transparent' }}
        className="select-none"
      />
    </div>
  );
};

export default Logo;
